module.exports = __webpack_public_path__ + "img/saudia-logo.b1818f08.jpg";